type EventProps = Record<string, string | number | undefined>;

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

/** Push a click/conversion event to the dataLayer (GTM-ready). */
export function trackEvent(event: string, props: EventProps = {}) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...props, path: window.location.pathname, ts: Date.now() });
}

export function trackCta(label: string, destination?: string) {
  trackEvent("cta_click", { label, destination });
}
